import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from "@material-ui/core";
import {AiFillFilePdf} from 'react-icons/ai'

const rows = [
  { description: "List of PIO, APIO & Appelate authority", pdfUrl: "https://tcp.hp.gov.in/Application/uploadDocuments/content/rti.pdf" },
  { description: "List of PIO, APIO & Appelate authority for Real Estate (Regulation and Development) Act,2016", pdfUrl: "https://tcp.hp.gov.in/Application/uploadDocuments/content/office_order_3.pdf" },
  { description: "PRO-ACTIVE DISCLOSURE OF INFORMATION UNDER RIGHT TO INFORMATION ACT, 2005", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Pro_Active.pdf" },

]

const handlePdfDownload = (pdfUrl) => {
  window.open(pdfUrl);
};

const AdminstrativeOrders = () => {
  return (
    <React.Fragment>
    <TableContainer component={Paper}>
    <Typography variant='h6' style={{margin: '20px'}}>
      Right to Information
    </Typography>
      <Table aria-label="Sample Table" style={{width: '90%', margin: '30px'}}>
        <TableHead>
          <TableRow style={{background: '#1F4A7C', height: '20px'}}>
            <TableCell style={{width: '60%', color: 'white'}}>Description</TableCell>
            <TableCell style={{width: '5%', color: 'white'}}>Download</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.slNo}>
              <TableCell>{row.description}</TableCell>
              <TableCell onClick={() => handlePdfDownload(row.pdfUrl)}><AiFillFilePdf style={{width: '30px', height: '30px', color:'#f44b55', cursor: 'pointer' }}/></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </React.Fragment>
  );
};

export default AdminstrativeOrders;
